var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-image"},[_c('img',{staticClass:"image-src",attrs:{"src":_vm.asset,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }